import { useEffect } from "react";

import { OrderFields } from "../../constants";
import useOrderData from "../../context/useOrderData";
import useOrderFormik from "../useOrderFormik";

const fieldName = OrderFields.PACKAGE_SIZE;

const useDefaultPackageSize = (): void => {
  const {
    values: { [fieldName]: currentValue },
    setFieldValue,
    setFieldError,
  } = useOrderFormik();

  const {
    dynamicData: { packageSizes },
  } = useOrderData();

  const defaultPackageSizeTitle = packageSizes[0]?.title;
  // If no value is currently selected and there are available package sizes - select first package size
  useEffect(() => {
    if (!currentValue && defaultPackageSizeTitle && setFieldValue) {
      setFieldValue(fieldName, defaultPackageSizeTitle);
      setFieldError(fieldName, undefined);
    }
  }, [setFieldValue, currentValue, setFieldError, defaultPackageSizeTitle]);

  // Check if current value is disabled, if yes, set current value to the first option
  useEffect(() => {
    if (currentValue && !packageSizes.find(({ title }) => title === currentValue) && setFieldValue) {
      setFieldValue(fieldName, defaultPackageSizeTitle || null);
      setFieldError(fieldName, undefined);
    }
  }, [currentValue, defaultPackageSizeTitle, packageSizes, setFieldError, setFieldValue]);
};
export default useDefaultPackageSize;
